import { apiClient as api } from './api';

// Blog service: CRUD operations against backend '/blogs' endpoints
export const blogService = {
  // List blogs (optionally with query params via object)
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).length) {
        params.append(key, String(value));
      }
    });
    const qs = params.toString();
    try {
      const res = await api.get(`/content/blogs${qs ? `?${qs}` : ''}`);
      return Array.isArray(res) ? res : (res.blogs || res.items || res.data || []);
    } catch {
      const res = await api.get(`/blogs${qs ? `?${qs}` : ''}`);
      return Array.isArray(res) ? res : (res.blogs || res.items || res.data || []);
    }
  },

  get: async (id) => {
    if (!id) throw new Error('blogService.get: id is required');
    try { return await api.get(`/content/blogs/${id}`); } catch { return await api.get(`/blogs/${id}`); }
  },

  create: async (payload) => {
    try { return await api.post('/content/blogs', payload); } catch { return await api.post('/blogs', payload); }
  },

  update: async (id, payload) => {
    if (!id) throw new Error('blogService.update: id is required');
    try { return await api.patch(`/content/blogs/${id}`, payload); } catch { return await api.put(`/blogs/${id}`, payload); }
  },

  remove: async (id) => {
    if (!id) throw new Error('blogService.remove: id is required');
    try { return await api.delete(`/content/blogs/${id}`); } catch { return await api.delete(`/blogs/${id}`); }
  },

  // Upload a blog cover image using FormData
  uploadCover: async (file) => {
    if (!file) throw new Error('blogService.uploadCover: file is required');
    const fd = new FormData();
    fd.append('cover', file);
    try {
      const res = await api.request('/content/blogs/upload-cover', { method: 'POST', body: fd });
      return res?.url || res?.secure_url || (res?.data && (res.data.url || res.data.secure_url)) || res;
    } catch {
      const res = await api.request('/blogs/upload-cover', { method: 'POST', body: fd });
      return res?.url || res?.secure_url || (res?.data && (res.data.url || res.data.secure_url)) || res;
    }
  }
};
